import api from './api';

const HistorialService = {
  // Historial general
  crearHistorial: (paciente_id) =>
    api.post(`/historiales/crear/${paciente_id}`),
  
  obtenerHistorial: (paciente_id) =>
    api.get(`/historiales/${paciente_id}`),

  // Notas de sesión
  agregarNotaSesion: (paciente_id, data) =>
    api.post(`/historiales/${paciente_id}/notas-sesion`, data),
  
  obtenerNotasSesion: (paciente_id) =>
    api.get(`/historiales/${paciente_id}/notas-sesion`),

  // Diagnósticos
  agregarDiagnostico: (paciente_id, data) =>
    api.post(`/historiales/${paciente_id}/diagnosticos`, data),
  
  obtenerDiagnosticos: (paciente_id) =>
    api.get(`/historiales/${paciente_id}/diagnosticos`),

  // Evoluciones
  agregarEvolucion: (paciente_id, data) =>
    api.post(`/historiales/${paciente_id}/evoluciones`, data),
  
  obtenerEvoluciones: (paciente_id) =>
    api.get(`/historiales/${paciente_id}/evoluciones`),

  // Antecedentes
  actualizarAntecedentes: (paciente_id, data) =>
    api.put(`/historiales/${paciente_id}/antecedentes`, data),
  
  obtenerAntecedentes: (paciente_id) =>
    api.get(`/historiales/${paciente_id}/antecedentes`),

  // Objetivos terapéuticos
  agregarObjetivo: (paciente_id, data) =>
    api.post(`/historiales/${paciente_id}/objetivos`, data),
  
  obtenerObjetivos: (paciente_id) =>
    api.get(`/historiales/${paciente_id}/objetivos`),
  
  actualizarProgresoObjetivo: (paciente_id, objetivo_id, progreso) =>
    api.put(`/historiales/${paciente_id}/objetivos/${objetivo_id}/progreso`, { progreso_porcentaje: progreso })
};

export default HistorialService;
